import React from 'react';
import { PropTypes } from 'prop-types';

const NumberRangeFilter = ({ column: { filterValue = { filter: [], filterType: 'between' }, setFilter } }) => {
  const [inputValue, setInputValue] = React.useState(filterValue.filter);
  const [showFilter, setShowFilter] = React.useState(false);
  const node = React.useRef();

  const handleClickOutside = (e) => {
    if (node === null || node.current === null) {
      return;
    }

    if (node.current.contains(e.target)) {
      // inside click
      return;
    }
    setShowFilter(false);
  };

  React.useEffect(() => {
    if (showFilter) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showFilter]);

  return (
    <div ref={ node } className={ `clickover clickover-bottom filter ${ showFilter ? 'active' : '' }` }>
      <button type="button" onClick={ () => setShowFilter(!showFilter) } className={ `btn btn-link filter-menu ${ filterValue?.filter && filterValue.filter.length > 0 && filterValue.filter[0] !== null ? 'filter-active' : '' }` }>☰</button>
      <div className="clickover-container">
        <div className="card card-primary">
          <div className="card-body">
            <div className="columns">
              <div className="col-12">
                <div style={ { display: 'flex', color: 'black' } }>
                  <input
                    value={ inputValue[0] >= 0 ? inputValue[0].toString() : '' }
                    type="number"
                    min="0"
                    onChange={ (e) => {
                      const val = e.target.value;
                      setInputValue((old = []) => {
                        const newValue = [val >= 0 ? parseInt(val, 10) : undefined, old[1]];
                        return newValue;
                      });
                    } }
                    style={ { width: '50%', marginRight: '0.5rem' } }
                  />
                  to
                  <input
                    value={ inputValue[1] >= 0 ? inputValue[1].toString() : '' }
                    type="number"
                    min="0"
                    onChange={ (e) => {
                      const val = e.target.value;
                      setInputValue((old = []) => {
                        const newValue = [old[0], val >= 0 ? parseInt(val, 10) : undefined];
                        return newValue;
                      });
                    } }
                    style={ { width: '50%', marginLeft: '0.5rem' } }
                  />
                </div>
              </div>
              <div className="col-6">
                <button
                  id="search-btn"
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={ () => {
                    setShowFilter(false);
                    setFilter({ filter: inputValue, filterType: 'between' });
                  } }
                ><span className="icon icon-search" /> Filter</button>
              </div>
              <div className="col-6">
                <button
                  id="clear-btn"
                  type="button"
                  className="btn btn-primary btn-sm"
                  disabled={ inputValue === [] }
                  onClick={ () => {
                    setShowFilter(false);
                    setInputValue([]);
                    setFilter({ filter: [], filterType: 'between' });
                  } }
                ><span className="icon icon-cross" /> Clear</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

NumberRangeFilter.propTypes = {
  column: PropTypes.shape().isRequired,
};

NumberRangeFilter.defaultProps = {};

export default NumberRangeFilter;
